module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jAtbb"))).then(() => parcelRequire('9Lwss'));